// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jcbs-sub-app-bo-con-st {
    width: 100%;
    max-width: var(--global-desktop-width-resp);
    height: auto;
    padding: 120px var(--global-desktop-padding-left) 120px var(--global-desktop-padding-right);
    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
    display: flex;
    gap: 20px;
}

.scl--jbs-sub-jb-tex-st {
    gap: 70px;
}

.scl--jcbs-sub-app-bo-con-st .scl--web-component-section-title-container .scl--web-component-section-title-text-container h2 {
    font-size: 50px;
    font-weight: 500;
}

.scl--jsabcs-bo-st {
    width: 500px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 65px;
}

.scl--jbs-car-ti-bo-dis-st {
    width: 461px;
    height: 451px;
    border-radius: 10px;
    border: 1.5px solid rgba(37, 37, 37, 1);
    padding: 25px;
}

.scl--jbs-car-ti-bo-dis-st p,
.scl--jbs-car-ti-bo-dis-st span {
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: lighter;
    color: rgba(125, 129, 135, 1);
    line-height: 30px;
}

.scl--jbs-car-ti-bo-dis-st .p-jbs{
    padding-bottom: 10px;
}

.scl--jbs-car-ti-bo-dis-st .span-jbs{
    padding-bottom: 10px;
}

.scl--jbs-car-ti-bo-dis-st .scl--jctbds-btn-st {
    min-width: 147px;
    flex: none;
    margin-top: 15px;
}

.scl--jctbds-btn-st span {
    color: rgba(255, 255, 255, 1);
    font-size: 16px;

}

.scl--jsbcs-bo-inp-co-st {
    width: calc(100% - 500px);
    height: auto;
    max-width: 855px;
    overflow: visible;
}

.scl--jsbcs-bo-inp-co-st form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: visible;
}

.scl--jbcs-num-bo-st {
    width: 100%;
    height: auto;
    display: flex;
    gap: 15px;
    overflow: visible;
}

.scl--jnbs-coun-se-bo-st {
    width: 153px;
    height: auto;
    position: relative;
}

.scl--jnbs-coun-se-bo-st .scl--web-component-country-select-dropdown {
    z-index: 100;
}

.scl--jnbs-pho-num-bo-st {
    width: calc(100% - 153px);
    height: auto;
}

.scl--jbics-val-bo-ch-st {
    width: 100%;
    display: flex;
    align-items: start;
    gap: 40px;
    margin-top: 20px;
}

.scl--jvbcs-des-bo-st {
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: lighter;
    color: rgba(125, 129, 135, 1);
    line-height: 30px;
}

.scl--jvbcs-des-bo-st span {
    color: #fff;
}

.scl--fi-bo-up-co-st {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.scl--fbucs-grp-at-up-st {
    display: flex;
    gap: 20px;
    align-items: center;
}

.scl--fgaus-ro-bt-st {
    width: 136px;
}

.scl--fgaus-sp-te-st {
    width: 50%;
    font-size: 14px;
    font-family: var(--primary-font);
    font-weight: lighter;
    color: rgba(125, 129, 135, 1);
}

.scl--fsts-req-st {
    color: red;
}

.scl--fbucs-su-bt-cd-st {
    width: 140px;
    background-color: rgba(255, 255, 255, 0.2);
}

.scl--jsbcs-bo-inp-co-st .scl--web-component-text-field-label.floating {
    background: #131313;
}

.scl--jsbcs-bo-inp-co-st .scl--web-component-text-field-input-plate:focus-within .scl--web-component-text-field-label {
    background: #131313;
}

.scl--jsbcs-bo-inp-co-st .scl--web-component-country-select-label.floating {
    background: #131313;
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobSubmitted.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,2FAA2F;IAC3F,mEAAmE;IACnE,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".scl--jcbs-sub-app-bo-con-st {\n    width: 100%;\n    max-width: var(--global-desktop-width-resp);\n    height: auto;\n    padding: 120px var(--global-desktop-padding-left) 120px var(--global-desktop-padding-right);\n    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n    display: flex;\n    gap: 20px;\n}\n\n.scl--jbs-sub-jb-tex-st {\n    gap: 70px;\n}\n\n.scl--jcbs-sub-app-bo-con-st .scl--web-component-section-title-container .scl--web-component-section-title-text-container h2 {\n    font-size: 50px;\n    font-weight: 500;\n}\n\n.scl--jsabcs-bo-st {\n    width: 500px;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 65px;\n}\n\n.scl--jbs-car-ti-bo-dis-st {\n    width: 461px;\n    height: 451px;\n    border-radius: 10px;\n    border: 1.5px solid rgba(37, 37, 37, 1);\n    padding: 25px;\n}\n\n.scl--jbs-car-ti-bo-dis-st p,\n.scl--jbs-car-ti-bo-dis-st span {\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n    color: rgba(125, 129, 135, 1);\n    line-height: 30px;\n}\n\n.scl--jbs-car-ti-bo-dis-st .p-jbs{\n    padding-bottom: 10px;\n}\n\n.scl--jbs-car-ti-bo-dis-st .span-jbs{\n    padding-bottom: 10px;\n}\n\n.scl--jbs-car-ti-bo-dis-st .scl--jctbds-btn-st {\n    min-width: 147px;\n    flex: none;\n    margin-top: 15px;\n}\n\n.scl--jctbds-btn-st span {\n    color: rgba(255, 255, 255, 1);\n    font-size: 16px;\n\n}\n\n.scl--jsbcs-bo-inp-co-st {\n    width: calc(100% - 500px);\n    height: auto;\n    max-width: 855px;\n    overflow: visible;\n}\n\n.scl--jsbcs-bo-inp-co-st form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    overflow: visible;\n}\n\n.scl--jbcs-num-bo-st {\n    width: 100%;\n    height: auto;\n    display: flex;\n    gap: 15px;\n    overflow: visible;\n}\n\n.scl--jnbs-coun-se-bo-st {\n    width: 153px;\n    height: auto;\n    position: relative;\n}\n\n.scl--jnbs-coun-se-bo-st .scl--web-component-country-select-dropdown {\n    z-index: 100;\n}\n\n.scl--jnbs-pho-num-bo-st {\n    width: calc(100% - 153px);\n    height: auto;\n}\n\n.scl--jbics-val-bo-ch-st {\n    width: 100%;\n    display: flex;\n    align-items: start;\n    gap: 40px;\n    margin-top: 20px;\n}\n\n.scl--jvbcs-des-bo-st {\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n    color: rgba(125, 129, 135, 1);\n    line-height: 30px;\n}\n\n.scl--jvbcs-des-bo-st span {\n    color: #fff;\n}\n\n.scl--fi-bo-up-co-st {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 30px;\n}\n\n.scl--fbucs-grp-at-up-st {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n}\n\n.scl--fgaus-ro-bt-st {\n    width: 136px;\n}\n\n.scl--fgaus-sp-te-st {\n    width: 50%;\n    font-size: 14px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n    color: rgba(125, 129, 135, 1);\n}\n\n.scl--fsts-req-st {\n    color: red;\n}\n\n.scl--fbucs-su-bt-cd-st {\n    width: 140px;\n    background-color: rgba(255, 255, 255, 0.2);\n}\n\n.scl--jsbcs-bo-inp-co-st .scl--web-component-text-field-label.floating {\n    background: #131313;\n}\n\n.scl--jsbcs-bo-inp-co-st .scl--web-component-text-field-input-plate:focus-within .scl--web-component-text-field-label {\n    background: #131313;\n}\n\n.scl--jsbcs-bo-inp-co-st .scl--web-component-country-select-label.floating {\n    background: #131313;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
